import { rootApi } from 'root-api'

const SCHEDULING_ASSISTANT_SETINGS_PREFIX = 'ai_exec_assistant'

export const SCHEDULING_ASSISTANT_ENABLED_SETTING_NAME = `${SCHEDULING_ASSISTANT_SETINGS_PREFIX}_enabled`
export const SCHEDULING_ASSISTANT_ENABLED_SETTING_TYPE = 'BOOLEAN'
export const SCHEDULING_ASSISTANT_PRIMARY_EVENT_TYPE_SETTING_NAME = `${
  SCHEDULING_ASSISTANT_SETINGS_PREFIX}_primary_event_type_uuid`
export const SCHEDULING_ASSISTANT_PRIMARY_EVENT_TYPE_SETTING_TYPE = 'STRING'
export const SCHEDULING_ASSISTANT_MUTUAL_AVAILABILITY_SCOPE_SETTING_NAME = `${
  SCHEDULING_ASSISTANT_SETINGS_PREFIX}_mutual_availability_scope`
export const SCHEDULING_ASSISTANT_MUTUAL_AVAILABILITY_SCOPE_SETTING_TYPE = 'STRING'
export const SCHEDULING_ASSISTANT_EXPANDED_AVAILABILITY_WITHOUT_CONFIRMATION_SETTING_NAME = `${
  SCHEDULING_ASSISTANT_SETINGS_PREFIX}_expanded_availability_without_confirmation`
export const SCHEDULING_ASSISTANT_EXPANDED_AVAILABILITY_WITHOUT_CONFIRMATION_SETTING_TYPE = 'BOOLEAN'
export const SCHEDULING_ASSISTANT_ONBOARDING_STATE_SETTING_NAME = `${
  SCHEDULING_ASSISTANT_SETINGS_PREFIX}_onboarding_state`

/** Saved setting values for `SCHEDULING_ASSISTANT_MUTUAL_AVAILABILITY_SCOPE_SETTING_NAME` */
export const MUTUAL_AVAILABILITY_SCOPE_NONE = 'none'
export const MUTUAL_AVAILABILITY_SCOPE_ALL = 'all'
export const MUTUAL_AVAILABILITY_SCOPE_SAME_ORG = 'same_org'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    enableEmailAgent: build.mutation({
      query: (body) => ({
        url: '/api/email_agent/enable',
        method: 'POST',
        ...(body ? { data: body } : {})
      }),
      // setup_callie writes primary ET + enabled in the monolith; refresh the settings cache.
      invalidatesTags: (_result, _error, arg) => (
        arg?.setup_callie ? ['SchedulingAssistantSettings'] : []
      )
    }),
    disableEmailAgent: build.mutation({
      query: () => ({
        url: '/api/email_agent/disable',
        method: 'POST'
      })
    }),
    sendDemoEmail: build.mutation({
      query: () => ({
        url: '/api/email_agent/send_demo_email',
        method: 'POST'
      })
    }),
    fetchSchedulingAssistantSettings: build.query({
      query: (userUuid) => ({ url: `/api/notetaker/settings/user/${userUuid}` }),
      transformResponse: (response) => {
        const settings = Array.isArray(response) ? response : []
        return settings.filter(
          (s) => (s.settingName || '').startsWith(SCHEDULING_ASSISTANT_SETINGS_PREFIX)
        )
      },
      providesTags: ['SchedulingAssistantSettings']
    }),
    fetchCallieEventType: build.query({
      query: (uuid) => ({ url: `/api/callie_event_types/${uuid}` }),
      providesTags: (result, error, uuid) => [{ type: 'CallieEventType', id: uuid }]
    }),
    updateCallieEventType: build.mutation({
      // The onboarding chat answers one question at a time and sends named fields. The
      // settings form diffs the whole event type, so it passes an already-shaped payload.
      query: ({ uuid, attributes, duration, locationConfigurationsAttributes }) => ({
        url: `/api/callie_event_types/${uuid}`,
        method: 'PATCH',
        data: {
          ...attributes,
          ...(duration !== undefined ? { duration } : {}),
          ...(locationConfigurationsAttributes ? { location_configurations_attributes: locationConfigurationsAttributes } : {}),
        },
      }),
      invalidatesTags: (_r, _e, { uuid }) => [{ type: 'CallieEventType', id: uuid }],
    }),
    postSchedulingAssistantSetting: build.mutation({
      query: ({ userUuid, settingName, settingValue, settingType }) => ({
        url: `/api/notetaker/settings/user/${userUuid}/${settingName}`,
        method: 'POST',
        data: { settingValue, settingType }
      }),
      invalidatesTags: ['SchedulingAssistantSettings']
    })
  }),
})

export const {
  useEnableEmailAgentMutation,
  useDisableEmailAgentMutation,
  useSendDemoEmailMutation,
  useFetchSchedulingAssistantSettingsQuery,
  useFetchCallieEventTypeQuery,
  useUpdateCallieEventTypeMutation,
  usePostSchedulingAssistantSettingMutation
} = api
